import React from "react"
import "./ActivityCard.scss"
import { selectIcon, SVG } from "../../../components/UI/selector"
import moment from "moment"
import { useHistory } from "react-router-dom"

export default function ActivityCard({ activityInfo }) {
  const tags = (
    <div className="Tags">
      <span className="Tag box-layer-forth text-caption2">
        {activityInfo.tags[0]}
      </span>
      {activityInfo.tags.length > 1 && (
        <span className="Tag box-layer-forth text-caption2">
          {activityInfo.tags.length - 1}
        </span>
      )}
    </div>
  )

  const history = useHistory()

  function handleOnClick(id, userActSessionId) {
    history.push(`/ClassSummary/${id}/${userActSessionId}/${false}`)
  }

  return (
    <div
      className="ActivityCard box-layer2"
      onClick={() =>
        handleOnClick(activityInfo.id, activityInfo.userActSessionId)
      }
    >
      <div className="ActivityMainInfo">
        <img
          src={activityInfo.image}
          height={100}
          width={100}
          className="ActivityImage"
        />
        <div className="ActivityInfo">
          <p className="ActivityName text-h2">{activityInfo.name}</p>
          <p className="WithCoach text-caption2">with {activityInfo.coach}</p>
          {tags}
          <p className="Duration text-caption2">
            <SVG src={selectIcon("clock")} height={12} />
            {activityInfo.duration} &nbsp;{" "}
            {activityInfo.duration === 1 ? <span>Min</span> : <span>Mins</span>}
          </p>
        </div>
      </div>
      <div className="ActivityFooter text-caption2">
        <div className="ActivityCalories">
          <img src={selectIcon("calories_icon1")} height={15} />
          &nbsp;{activityInfo.calories}
        </div>
        <div className="UserRank">
          <SVG src={selectIcon("rank_icon")} height={15} />
          &nbsp;{activityInfo.rank}
        </div>
        <div className="ActivityDateTime">
          <SVG src={selectIcon("watch")} height={15} />
          {moment(activityInfo.date).format("MMM D, h:mm A")}
        </div>
      </div>
    </div>
  )
}
